module.exports = __webpack_public_path__ + "static/img/en-MX.7ce6751f.svg";